import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Redirect } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars";

import Aux from "../Aux";
import Loading from "../../components/Loading";
import PageHeader from "../../components/PageHeader";
import FormWrapper from "../../components/FormWrapper";
import FlexWrapper from "../../components/FlexWrapper";
import EditSideColumn from "./components/EditSideColumn";

import {
  getUser,
  removeUser,
  getUserGroups,
  editUser
} from "../../store/Users/services";

import { validateUser } from "../../utils/UserPermissions";

import Form from "./Form";

class Edit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      requiredPermissions: ["EDIT_USERS", "ALL"]
    };
  }

  submit = async values => {
    const id = this.props.match.params.id;
    this.props.dispatch(editUser(id, values));
  };

  remove = () => {
    const id = [this.props.match.params.id];
    if (this.props.user.is_admin) {
      return alert("You cannot remove a user account.");
    }
    const confirm = window.confirm(
      "Are you sure you want to remove " + this.props.user.first_name + "?"
    );
    if (confirm) {
      this.props.dispatch(removeUser(id));
    }
  };

  componentDidMount() {
    validateUser(this.props.permissions, this.state.requiredPermissions);
    this.props.dispatch(getUser(this.props.match.params.id));
    this.props.dispatch(getUserGroups());
  }

  render() {
    let { loading, user, success } = this.props;
    if (loading) {
      return <Loading />;
    }
    if (success) {
      // Redirect when entry created
      return <Redirect to="/users" />;
    }
    return (
      <Aux>
        <PageHeader title={"Edit " + user.first_name + " " + user.last_name} />
        <FlexWrapper>
          <FormWrapper>
            <Scrollbars>
              <Form
                onSubmit={this.submit}
                mode="edit"
                userGroups={this.props.groups}
                initialValues={this.props.user}
              />
            </Scrollbars>
          </FormWrapper>
          <EditSideColumn
            submit={this.submit}
            permissions={this.props.permissions}
            mode="edit"
            remove={this.remove}
          />
        </FlexWrapper>
      </Aux>
    );
  }
}

function mapStateToProps(store) {
  return {
    user: store.user.user,
    success: store.user.success,
    permissions: store.auth.permissions,
    error: store.user.error,
    groups: store.user.groups,
    groupsLoading: store.user.groupsLoading,
    loading: store.user.isLoading
  };
}

export default withRouter(connect(mapStateToProps)(Edit));



// WEBPACK FOOTER //
// ./src/system/containers/Users/Edit.jsx